import React, { useState, useEffect, useMemo } from 'react';
import '../styles/WelcomeSplash.css';

const LOGO_DARK = 'https://customer-assets.emergentagent.com/job_422444ca-8f0f-4ebc-8f78-bee66ce7f723/artifacts/qo6wuzuf_REGISTAN%20LOGO.png';

const WelcomeSplash = ({ onComplete }) => {
  const [phase, setPhase] = useState('enter'); // enter -> hold -> exit

  useEffect(() => {
    const holdTimer = setTimeout(() => setPhase('hold'), 100);
    const exitTimer = setTimeout(() => setPhase('exit'), 1800);
    const doneTimer = setTimeout(() => onComplete(), 2400);
    return () => { clearTimeout(holdTimer); clearTimeout(exitTimer); clearTimeout(doneTimer); };
  }, [onComplete]);

  // Pre-generate star particles
  const particles = useMemo(() => {
    const arr = [];
    for (let i = 0; i < 36; i++) {
      arr.push({
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 1.5}s`,
        duration: `${1.2 + Math.random() * 1.8}s`,
      });
    }
    return arr;
  }, []);

  return (
    <div
      className={`splash-overlay splash-${phase}`}
      data-testid="welcome-splash"
    >
      {/* Radial gradient ambient */}
      <div className="splash-ambient" aria-hidden="true" />

      {/* Grid backdrop */}
      <div className="splash-grid" aria-hidden="true" />

      {/* Twinkling particles */}
      <div className="splash-particles" aria-hidden="true">
        {particles.map((p, i) => (
          <span
            key={i}
            className="splash-particle"
            style={{
              top: p.top,
              left: p.left,
              animationDelay: p.delay,
              animationDuration: p.duration,
            }}
          />
        ))}
      </div>

      {/* Rotating dotted globe */}
      <svg className="splash-globe" viewBox="0 0 320 320" aria-hidden="true">
        <defs>
          <radialGradient id="globeGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="rgba(94, 252, 232, 0.25)" />
            <stop offset="100%" stopColor="rgba(94, 252, 232, 0)" />
          </radialGradient>
        </defs>
        <circle cx="160" cy="160" r="150" fill="url(#globeGlow)" />
        {/* Latitude lines */}
        {[40, 80, 120, 160, 200, 240, 280].map((y, i) => (
          <ellipse
            key={`lat-${i}`}
            cx="160"
            cy={y}
            rx="150"
            ry={Math.max(6, 150 - Math.abs(160 - y))}
            fill="none"
            stroke="rgba(94, 252, 232, 0.35)"
            strokeWidth="0.6"
            strokeDasharray="2 4"
          />
        ))}
        {/* Longitude lines */}
        {[30, 60, 90, 120, 150].map((rx, i) => (
          <ellipse
            key={`lon-${i}`}
            cx="160"
            cy="160"
            rx={rx}
            ry="150"
            fill="none"
            stroke="rgba(94, 252, 232, 0.3)"
            strokeWidth="0.6"
            strokeDasharray="2 4"
          />
        ))}
        <circle cx="160" cy="160" r="150" fill="none" stroke="rgba(94, 252, 232, 0.55)" strokeWidth="1" />
      </svg>

      {/* Scan line sweep */}
      <div className="splash-scan" aria-hidden="true" />

      {/* Center content */}
      <div className="splash-center">
        <div className="splash-logo-wrap">
          {/* Decorative ring */}
          <svg className="splash-ring" viewBox="0 0 200 200" aria-hidden="true">
            <circle cx="100" cy="100" r="96" fill="none" stroke="url(#ringGradient)" strokeWidth="1.5" strokeDasharray="603" strokeDashoffset="603" />
            <defs>
              <linearGradient id="ringGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#5EFCE8" />
                <stop offset="100%" stopColor="#7c6cff" />
              </linearGradient>
            </defs>
          </svg>
          <img src={LOGO_DARK} alt="Registan Tourism" className="splash-logo-img" />
        </div>
        <div className="splash-brand" aria-label="Registan Tourism">
          {'REGISTAN'.split('').map((c, i) => (
            <span key={i} className="splash-char" style={{ animationDelay: `${0.6 + i * 0.05}s` }}>{c}</span>
          ))}
          <span className="splash-char-space"> </span>
          {'TOURISM'.split('').map((c, i) => (
            <span key={i + 100} className="splash-char" style={{ animationDelay: `${1.0 + i * 0.05}s` }}>{c}</span>
          ))}
        </div>
        <div className="splash-tagline">Smart Visa Solutions for UAE</div>
        <div className="splash-loader">
          <div className="splash-loader-fill" />
        </div>
      </div>

      {/* Corner accents */}
      <div className="splash-corner tl" aria-hidden="true" />
      <div className="splash-corner tr" aria-hidden="true" />
      <div className="splash-corner bl" aria-hidden="true" />
      <div className="splash-corner br" aria-hidden="true" />
    </div>
  );
};

export default WelcomeSplash;
